var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.642,
    height: 60,
    viewBox: "0 0 59.642 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-98.563 -26.88)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89930",
    "data-name": "Path 89930",
    d: "M118.288,79.016a1.242,1.242,0,0,0-1.594,1.66l.465.93A27.306,27.306,0,1,1,155.68,56.7a1.262,1.262,0,1,0,2.524,0,29.821,29.821,0,1,0-54.2,17.2A29.551,29.551,0,0,0,116.363,84l-1.129.531a1.227,1.227,0,0,0,.066,2.258h.066a.924.924,0,0,0,.93-.066l3.786-1.727a1.272,1.272,0,0,0,.6-1.66l-.531-1.129-1.2-2.656a1.387,1.387,0,0,0-.664-.532Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89931",
    "data-name": "Path 89931",
    d: "M340.621,70.908a1.261,1.261,0,0,0,1.262-1.262v-7.9a1.262,1.262,0,0,0-2.524,0v7.9a1.221,1.221,0,0,0,1.262,1.262Z",
    transform: "translate(-212.238 -29.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89932",
    "data-name": "Path 89932",
    d: "M481.181,270.762h7.9a1.261,1.261,0,0,0,1.262-1.262,1.306,1.306,0,0,0-1.262-1.262h-7.9a1.261,1.261,0,0,0-1.262,1.262A1.307,1.307,0,0,0,481.181,270.762Z",
    transform: "translate(-336.127 -212.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89933",
    "data-name": "Path 89933",
    d: "M140.828,267.68h-7.97a1.262,1.262,0,1,0,0,2.524h7.9a1.263,1.263,0,0,0,.067-2.524Z",
    transform: "translate(-29.115 -212.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89934",
    "data-name": "Path 89934",
    d: "M340.621,267.68a1.262,1.262,0,1,0,1.262,1.262A1.261,1.261,0,0,0,340.621,267.68Z",
    transform: "translate(-212.238 -212.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89935",
    "data-name": "Path 89935",
    d: "M257.92,184.447a1.268,1.268,0,1,0-1.793,1.793l7.173,7.173a1.262,1.262,0,0,0,1.793,0,1.327,1.327,0,0,0,0-1.793Z",
    transform: "translate(-138.569 -138.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89936",
    "data-name": "Path 89936",
    d: "M379.321,127.887a1.327,1.327,0,0,0-1.793,0l-13.881,13.881a1.327,1.327,0,0,0,0,1.793,1.262,1.262,0,0,0,1.793,0l13.881-13.881A1.326,1.326,0,0,0,379.321,127.887Z",
    transform: "translate(-233.337 -88.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89937",
    "data-name": "Path 89937",
    d: "M346.96,337.12h-9.63a1.261,1.261,0,0,0-1.262,1.262,1.306,1.306,0,0,0,1.262,1.262h9.63a.666.666,0,0,1,.664.664v5.513a.666.666,0,0,1-.664.664h-7.771A3.189,3.189,0,0,0,336,349.672v5.513a3.189,3.189,0,0,0,3.188,3.188h9.7a1.261,1.261,0,0,0,1.262-1.262,1.306,1.306,0,0,0-1.262-1.262h-9.7a.666.666,0,0,1-.664-.664v-5.645a.638.638,0,0,1,.6-.465h7.837a3.189,3.189,0,0,0,3.188-3.188v-5.513a3.2,3.2,0,0,0-3.188-3.254Z",
    transform: "translate(-209.278 -273.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89938",
    "data-name": "Path 89938",
    d: "M495.535,337.12a1.261,1.261,0,0,0-1.262,1.262v8.037H485.9a.666.666,0,0,1-.664-.664v-7.372a1.262,1.262,0,1,0-2.524,0v7.372a3.189,3.189,0,0,0,3.188,3.188h8.368v8.037a1.261,1.261,0,0,0,1.262,1.262,1.306,1.306,0,0,0,1.262-1.262v-18.6a1.221,1.221,0,0,0-1.262-1.262Z",
    transform: "translate(-338.593 -273.446)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9cb621756ef84ec0d4c845120ed581b2.svg";
export { ForwardRef as ReactComponent };